const variables = {
  pumpHousing: "Pump Housing - Temperature",
  cPbar11: "In Board - Pressure",
  fPbar11: "Out Board - Pressure",
  fiTc23: "FI - Temperature",
  shTc23: "Stuffing Box - Temperature",
  shPbar23: "Stuffing Box - Pressure",
  cwTinC23: "Cooling Water In - Temperature",
  cwTouTc23: "Cooling Water Out - Temperature",
  fiTcC32: "In Board - Temperature",
  fiPbarC32: "In Board - Pressure",
  fiTcF32: "Out Board - Temperature",
  fiPbarF32: "Out Board - Pressure",
  cwInTc52: "Cooling Water In - Temperature",
  cwOutTc52: "Cooling Water Out - Temperature",
  oilOutTc52: "Oil Out - Temperature",
  oilInTc52: "Oil In - Temperature",
  shPbar52: "Stuffing Box - Pressure ",
  pBar52: "Plan API 52 - Pressure",
  level52: "Plan API 52 - Level",
  cBpiTc53b: "In Board - BPI Temperature",
  cBpoPbar53b: "In Board - BPO Pressure",
  cBpoTc53b: "In Board - BPO Temperature",
  cCwInTc53b: "Cooling Water -In Board In - Temperature",
  cCwOutTc53b: "Cooling Water -In Board Out - Temperature",
  cFwInTc53b: "Cooling Water -Out Board In - Temperature",
  cFwOutTc53b: "Cooling Water -Out Board Out  - Temperature",
  cRsPbar53b: "Refilling System -  In Board - Pressure ",
  fBpiTc53b: "Out Board -  BPI Temperature",
  fBpoPbar53b: "Out Board -  BPO Pressure ",
  fBpoTc53b: "Out Board -  BPO Temper",
  fRsPbar53b: "Refilling System - Out Board  - Pressure",
  iaPbar53b: "Instrument Air  - Pressure",
  sysPbar53b: "System - Pressure",
  tankLevel53b: "Tank - Level",
  bpiPbar54: "In Board-BPI - Pressure",
  bpiTc54: "In Board- BPI - Temperature",
  bpoPbar54: "In Board- BPO  - Pressure",
  bpoTc54: "In Board- BPO  - Temperature",
  cwInTc54: "In Board- Cooling Water In - Temperature",
  cwOutTc54: "In Board- Cooling Water Out - Temperature",
  fbpiPbar54: "Out Board-BPI - Pressure",
  fbpiTc54: "Out Board- BPI - Temperature",
  fbpoPbar54: "Out Board- BPO  - Pressure",
  fbpoTc54: "Out Board- BPO  - Temperature",
  fcwInTc54: "Out Board - Cooling Water In - Temperature",
  fcwOutTc54: "Out Board - Cooling Water Out - Temperature",
  fflowLpm54: "Out Board - Barrier Flow",
  flevelL54: "Out Board - Level",
  flowLpm54: "In Board - Barrier Flow",
  fmotorTc54: "Out Board - Motor - Temperature",
  levelL54: "In Board - Level",
  motorTc54: "In Board- Motor - Temperature",
  pumpPressIn: "Presión de Succión",
  pumpPressOut: "Presión de Descarga",
  pumpRotorSpeed: "Velocidad del Rotor",
  pumpOilLevel: "Nivel de Aceite",
  pumpOutflow: "Flujo de Salida",
  pumpTempFluid: "Temperatura del Fluido",
  compressor1StageTemp: "Temperatura de Etapa 1",
  compressor2StageTemp: "Temperatura de Etapa 2",
  compressor3StageTemp: "Temperatura de Etapa 3",
  compressor4StageTemp: "Temperatura de Etapa 4",
  compressor5StageTemp: "Temperatura de Etapa 5",
  compressor6StageTemp: "Temperatura de Etapa 6",
  compressor7StageTemp: "Temperatura de Etapa 7",
  compressor8StageTemp: "Temperatura de Etapa 8",
  compressor9StageTemp: "Temperatura de Etapa 9",
  compressor10StageTemp: "Temperatura de Etapa 10",
  compressor1StagePressure: "Presión de Salida de Etapa 1",
  compressor2StagePressure: "Presión de Salida de Etapa 2",
  compressor3StagePressure: "Presión de Salida de Etapa 3",
  compressor4StagePressure: "Presión de Salida de Etapa 4",
  compressor5StagePressure: "Presión de Salida de Etapa 5",
  compressor6StagePressure: "Presión de Salida de Etapa 6",
  compressor7StagePressure: "Presión de Salida de Etapa 7",
  compressor8StagePressure: "Presión de Salida de Etapa 8",
  compressor9StagePressure: "Presión de Salida de Etapa 9",
  compressor10StagePressure: "Presión de Salida de Etapa 10",
  compressorPressureDifference: "Diferencia de Presión en Filtro",
  compressorTemperatureIn: "Temperatura de Entrada del Aceite",
  compressorDewPoint: "Temperatura del Punto de Rocío",
  compressorOilLevel: "Nivel de Aceite",
  compressorOutflow: "Flujo de Salida",
  compressorPressIn: "Presión de Succión",
  compressorPressOut: "Presión de Descarga",
  compressorPressureDifference1: "Diferencia de Presión (interetapas)",
  compressorNumberOfStages: "Número de Etapas",
  compressorDriver: "Driver",
  compressorMaxSpeed: "Velocidad Máxima",
  compressorPlantAirPressure: "Presión de Aire de la Planta",
  compressorOilPressure: "Presión de Aceite",
  compressorLowPinionVibration: "Vibración piñón baja",
  compressorHighPinionVibration: "Vibración piñón alta",
  compressorSpeed: "Velocidad",
  compressorElectricityConsumption: "Consumo de corriente",
  compressorCoolingWater: "Temperatura del Agua de Enfriamiento",
  engineVoltage: "Voltaje",
  enginePower: "Potencia",
  engineEfficiency: "Eficiencia",
  engineDriven: "Driven",
  engineFrequency: "Frecuencia",
  engineSpeed: "Velocidad",
  enginePowerFactor: "Factor de Potencia",
  gearBoxInputSpeed: "Velocidad de Entrada del Eje",
  gearBoxOutputSpeed: "Velocidad de Salida del Eje",
  gearBoxDriver: "Driver",
  gearBoxDriven: "Driven",
  gearBoxPower: "Potencia",
  gearServiceFactor: "Factor de Servicio",
  generatorVoltage: "Voltaje",
  generatorPower: "Potencia",
  generatorEfficiency: "Eficiencia",
  generatorDriven: "Driven",
  generatorFrequency: "Frecuencia",
  generatorSpeed: "Velocidad",
  generatorPowerFactor: "Factor de Potencia",
  ovenOperationPressure: "Presión de Operación",
  ovenOperationTemperature: "Temperatura de Operación",
  ovenDesignPressure: "Presión de Diseño",
  ovenDesignTemperature: "Temperatura de Diseño",
  ovenHeatAbsorption: "Absorción de Calor",
  ovenTubeSkinTemperature: "Temperatura de Piel del Tubo",
  ovenOxygenPercentage: "Porcentaje de Oxígeno",
  ovenVacuumPressure: "Presión de Vacío",
  ovenGasInput: "Entra de Gas",
  ovenOutputTemperature: "Temperatura de Salida",
  ovenCatalystLife: "Vida Útil del Catalizador ",
  turbineSpeed: "Velocidad",
  turbinePower: "Potencia",
  turbineTemperatureIn: "Temperatura de Entrada",
  turbinePressureIn: "Presión de Entrada",
  turbineDriven: "Driven",
  turbineNumberOfStages: "Número de Etapas",
  turbineMaxSpeed: "Velocidad Máxima",
  turbineExhaustPressure: "Contrapresión",
  turbineTripSpeed: "Trip Speed",
  boilerEconomizerFlow: "Flujo Economizador",
  boilerSteam: "Vapor",
  boilerAirFlow: "Flujo de Aire",
  boilerFuelFlow: "Flujo de Combustible",
  boilerExcessOxygen: "Exceso de Oxígeno",
  boilerSteamLevel: "Nivel de Vapor",
  boilerSteamPressure: "Presión de Vapor",
  boilerSteamTemperature: "Temperatura de Vapor",
  boilerOperationalTemperature: "Temperatura de Operación",
  boilerDesignTemperature: "Temperatura de Diseño",
  boilerDesignPressure: "Presión de Diseño",
  boilerOperationalPressure: "Presión de Operación",
  boilerSteamCapacity: "Capacidad de Vapor",
  boilerPH: "pH",
  heatExchangerShellTemperatureIn: "Temperatura de Entrada de la Carcasa",
  heatExchangerShellTemperatureOut: "Temperatura de Salida de la Carcasa",
  heatExchangerTubesTemperatureIn: "Temperatura de Entrada de los Tubos",
  heatExchangerTubesTemperatureOut: "Temperatura de Salida de los Tubos",
  heatExchangerLogMeanTemperatureDifference: "Temperatura Media Logarítmica",
  heatExchangerOperationalShellTemperature:
    "Temperatura de Operación de la Carcasa",
  heatExchangerDesignShellTemperature: "Temperatura de Diseño de la Carcasa",
  heatExchangerDesignShellPressure: "Presión de Diseño de la Carcasa",
  heatExchangerOperationalShellPressure: "Presión de Operación de la Carcasa",
  heatExchangerOperationalTubesTemperature:
    "Temperatura de Operación de los Tubos",
  heatExchangerDesignTubesTemperature: "Temperatura de Diseño de los Tubos",
  heatExchangerDesignTubesPressure: "Presión de Diseño de los Tubos",
  heatExchangerOperationalTubesPressure: "Presión Operacional de los Tubos",
  heatExchangerHeatCapacity: "Capacidad de Calor",
  reactorOperationalTemperature: "Temperatura de Operación",
  reactorOperationalPressure: "Presión de Operación",
  reactorDesignTemperature: "Temperatura de Diseño",
  reactorDesignPressure: "Presión de Diseño",
  reactorCatalystLifetime: "Tiempo de Vida del Catalizador",
  tankLevel: "Nivel",
  tankPH: "pH",
  tankConductivity: "Conductividad",
  tankConcentration: "Concentración",
  tankCapacity: "Capacidad",
  tankVolume: "Volumen",
  tankDesignTemperature: "Temperatura de Diseño",
  transformerElectricalPower: "Potencia Eléctrica",
  transformerPrimaryVoltage: "Voltaje del Primario",
  transformerSecundaryVoltage: "Voltage del Secundario",
  transformerPrimaryCurrent: "Corriente del Primario",
  transformerWindingTemperature: "Temperatura de bobinado",
  transformerImpedance: "Impedancia",
  transformerFrequency: "Frecuencia",
  concentration: "Concentración",
  pH: "pH",
  nitrite: "Nitrito",
  coolingLubricantCode: "Código del Lubricante de Refrigeración",
  flameStability: "Estabilidad de la llama",
  flameQualityColor: "Color de la llama",

  example4Values: "Ejemplo para 4 Valores",
  // Steps Variables update
  equipmentOperationMode: "Modo de Operacion del Equipo",
  ventValveMode: "Modo de válvula de venteo",
  airInletValveMode: "Modo de válvula de entrada de aire",
  ventingValve: "Válvula de venteo",
  airInletValve: "Válvula de entrada de aire",
  highVaporPressure: "Presión de vapor de alta"
};
export default variables;
